export const roundToNextEvenCent = (value) => {
  const num = Number(value) || 0;

  // convert to cents
  let cents = Math.round((num + Number.EPSILON) * 100);

  // if odd cent, move to next even cent
  if (cents % 2 !== 0) {
    cents += 1;
  }

  return cents / 100;
};

export const calculateRoundedGstAmount = (taxableAmount, gstRate) => {
  const taxable = Number(taxableAmount) || 0;
  const rate = Number(gstRate) || 0;

  if (taxable <= 0 || rate <= 0) {
    return 0;
  }

  const halfGst = roundToNextEvenCent(
    (taxable * rate) / 100 
  );

  return roundToNextEvenCent(halfGst);
};


/** Round to 2 decimals for calculations (matches MoneyFormatv3 display rounding). */
export const roundMoneyAmount = (number) => {
  if (isNaN(number) || number == null) {
    return 0;
  }
  if (number == '-0') {
    return 0;
  }
  return Math.round(Number(number) * 100) / 100;
};